var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"title",class:{uncheck:1,checked:_vm.formItem.value==1},on:{"click":_vm.changeCheckBox}},[_vm._v(_vm._s(_vm.formItem.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }